import validator from 'validator';

const emailHasConsecutiveDots = (value: string) => value.includes('..');

export const normalizeEmail = (email: string) => email.trim().toLowerCase();

export const validateEmail = (email: string) => {
  const normalized = normalizeEmail(email);

  if (!normalized) {
    return { ok: false, reason: 'Email is required.' };
  }

  if (/\s/.test(normalized)) {
    return { ok: false, reason: 'Email cannot contain spaces.' };
  }

  if (
    !validator.isEmail(normalized, {
      allow_utf8_local_part: false,
      ignore_max_length: false,
    })
  ) {
    return { ok: false, reason: 'Enter a valid email address.' };
  }

  const [local, domain] = normalized.split('@');
  if (!local || !domain) {
    return { ok: false, reason: 'Enter a valid email address.' };
  }

  if (
    local.startsWith('.') ||
    local.endsWith('.') ||
    domain.startsWith('.') ||
    domain.endsWith('.')
  ) {
    return { ok: false, reason: 'Email cannot start or end with a dot.' };
  }

  if (emailHasConsecutiveDots(local) || emailHasConsecutiveDots(domain)) {
    return { ok: false, reason: 'Email cannot contain consecutive dots.' };
  }

  const domainParts = domain.split('.');
  if (domainParts.length < 2) {
    return { ok: false, reason: 'Email must include a valid domain.' };
  }

  const tld = domainParts[domainParts.length - 1];
  if (!tld || tld.length < 2) {
    return { ok: false, reason: 'Email must include a valid top-level domain.' };
  }

  return { ok: true };
};
